module.exports = __webpack_public_path__ + "img/lymphomap.4ca179ee.png";